import Vue from 'vue/dist/vue.esm'

Vue.component("hubs-search-vue", () => import(/* webpackChunkName: "[request]" */ "components/hubs/Search"))
Vue.component("hubs-gallery-vue", () => import(/* webpackChunkName: "[request]" */ "components/hubs/Gallery"))
